export const ROLES = ['USER', 'ADMIN', 'SUPER_ADMIN'] as const;
export type Role = (typeof ROLES)[number];

/** Higher number = more privilege. Used for "outranks" checks. */
export const ROLE_RANK: Readonly<Record<Role, number>> = { USER: 0, ADMIN: 1, SUPER_ADMIN: 2 };

export const isRole = (value: unknown): value is Role =>
  typeof value === 'string' && (ROLES as readonly string[]).includes(value);

export const isAdminRole = (role: Role): boolean => ROLE_RANK[role] >= ROLE_RANK.ADMIN;
export const isSuperAdminRole = (role: Role): boolean => role === 'SUPER_ADMIN';
